import * as React from 'react'

export const IndicatorIcon = (props: React.ComponentProps<'svg'> | any) => {
  return (
    <svg {...props} viewBox="0 0 28 28" fill="none">
      <path stroke="currentColor" d="M6 12l4.8-4.8a1 1 0 0 1 1.4 0l2.7 2.7a1 1 0 0 0 1.3.1L23 5" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 12a1 1 0 0 0-1 1v4h-3v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v2H7a1 1 0 0 0-1 1v4h17V13a1 1 0 0 0-1-1h-3zm0 10h3v-9h-3v9zm-1 0v-4h-3v4h3zm-4-4.5V22h-3v-6h3v1.5zM10 22v-3H7v3h3z"
      />
    </svg>
  )
}
